import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `CompanyRoleRoot`
};

export function useCompanyRoleStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          padding: `5px`,
          width: `100%`,
          "& .ms-Dropdown-title": {
            border: `1px solid ${semanticColors.bodyDivider}`,
            height: `22px`,
            lineHeight: `20px`
          },
          "& .ms-Dropdown-caretDownWrapper": {
            height: `22px`,
            lineHeight: `20px`
          }
        }
      ]
    }),
    [semanticColors]
  );
}
